const modules = {}

const getters = {
	currentHP: (state, getters, rootState) => {
		return rootState.Character.Current.Points.Hit
	},
	currentSP: (state, getters, rootState) => {
		return rootState.Character.Current.Points.Stamina
	},
	currentRP: (state, getters, rootState) => {
		return rootState.Character.Current.Points.Resolve
	},
	currentTempHP: (state, getters, rootState) => {
		return rootState.Character.Current.Points.Temporary.HP
	},
	totalHP: (state, getters, rootState, rootGetters) => {
		var raceHP = parseInt(rootState.Character.Bio.Race['Hit Points'])
		var classHP = 0
		for(let level = 1; level <= rootGetters.currentLevel; level++){
			classHP += rootState.Character.Levels[level].HP
		}
		return raceHP + classHP
	},
	totalSP: (state, getters, rootState, rootGetters) => {
		var level, sp = 0
		for(level = 1; level <= rootGetters.currentLevel; level++){
			sp += rootState.Character.Levels[level].SP + rootGetters['character/abilityScores/abilityMods'].Constitution
		}
		return sp
	},
	totalRP: (state, getters, rootState, rootGetters) => {
		var resolve = 1;
		var modifier = rootGetters['character/abilityScores/abilityMods'][rootState.Character.KeyAbility]
		var misc = parseInt(rootState.Character.Misc.Resolve)||0

		if(Math.floor(rootGetters.currentLevel/2) > resolve){
			resolve = Math.floor(rootGetters.currentLevel/2);
		}
		resolve += modifier + misc;
		if(resolve > 0){
			return resolve
		}else{
			return 1
		}
	},
	totalTempHP: (state, getters, rootState) => {
		return rootState.Character.Current.Points.Temporary.Max
	},
	isTempHPActive: (state, getters, rootState) => {
		return rootState.Character.Current.Points.Temporary.Active
	},
	fastHealing: (state, getters, rootState) => {
		return rootState.Character.Current.Points.Temporary.Heal
	}
}

const actions = {
	setHP: ({ commit }, n) => {
		commit('setCharacterProp',[
			{
				key: `Current.Points.Hit`,
				val: n
			}
		],{
			root: true,
		})
	},
	setSP: ({ commit }, n) => {
		commit('setCharacterProp',[
			{
				key: `Current.Points.Stamina`,
				val: n
			}
		],{
			root: true,
		})
	},
	setRP: ({ commit }, n) => {
		commit('setCharacterProp',[
			{
				key: `Current.Points.Resolve`,
				val: n
			}
		],{
			root: true,
		})
	},
	setTempHP: ({ commit }, n) => {
		commit('setCharacterProp',[
			{
				key: `Current.Points.Temporary.HP`,
				val: n
			}
		],{
			root: true,
		})
	},
	resetRP: ({ commit, getters }) => {
		commit('setCharacterProp',[
			{
				key: `Current.Points.Resolve`,
				val: getters.totalRP
			}
		],{
			root: true,
		})
	},
	takeDamage: ({ getters, dispatch }, damage) => {
		var damageTaking = parseInt(damage);
		var tempHP = getters.currentTempHP;
		var tempHPactive = getters.isTempHPActive;
		var SP = getters.currentSP;
		var HP = getters.currentHP;

		//Temporary Hit Points
		if(tempHP > 0 && tempHPactive){
			//Damage will deplete pool
			if(damageTaking >= tempHP){
				damageTaking -= tempHP;
				dispatch('setTempHP', 0);
			}
			//Damage will not deplete pool
			else{
				dispatch('setTempHP', (tempHP - damageTaking) );
				damageTaking = 0;
			}
		}

		//Stamina Points
		if(SP > 0){
			//Damage will deplete pool
			if(damageTaking >= SP){
				damageTaking -= SP;
				dispatch('setSP', 0);
			}
			//Damage will not deplete pool
			else{
				dispatch('setSP', (SP - damageTaking) );
				damageTaking = 0;
			}
		}

		//Hit Points
		//Damage will deplete pool
		if(damageTaking >= HP){
			dispatch('setHP', 0);
		}
		//Damage will not deplete pool
		else{
			dispatch('setHP', (HP - damageTaking) );
			damageTaking = 0;
		}
	},
	healDamage: ({ getters, dispatch }, damage) => {
		var damageHealing = parseInt(damage);
		var HP = getters.currentHP;
		var HPmax = getters.totalHP;

		if(HP + damageHealing > HPmax){
			dispatch('setHP', HPmax);
		}else{
			dispatch('setHP', (HP + damageHealing) )
		}
	},
	reset: ({ getters, dispatch }) => {
		dispatch('setHP', getters.totalHP)
		dispatch('setSP', getters.totalSP)
		dispatch('setRP', getters.totalRP)
	},
	activateTempHP: ({ commit, getters }) => {
		commit('setCharacterProp',[
			{
				key: `Current.Points.Temporary.Active`,
				val: true,
			},
			{
				key: `Current.Points.Temporary.HP`,
				val: getters.totalTempHP,
			}
		],{
			root: true,
		})
	},
	deactivateTempHP: ({ commit }) => {
		commit('setCharacterProp',[
			{
				key: `Current.Points.Temporary.Active`,
				val: false
			}
		],{
			root: true,
		})
	},
	refreshTempHP: ({ dispatch, getters }) => {
		let tempHP = getters.currentTempHP;
		const tempHPmax = getters.totalTempHP;
		const tempHPheal = getters.fastHealing;

		if(tempHP < tempHPmax){
			if(tempHP + tempHPheal > tempHPmax){
				tempHP = tempHPmax;
			}else{
				tempHP += tempHPheal;
			}
		}
		dispatch('setTempHP',tempHP)
	},
	restLong: ({ dispatch, getters, rootGetters }) => {
		dispatch('setRP', getters.totalRP)
		dispatch('setSP', getters.totalSP)
		dispatch('setHP', (getters.currentHP + rootGetters.currentLevel) )
	},
	restShort: ({ dispatch, getters }) => {
		dispatch('setSP', getters.totalSP)
		dispatch('setRP', (getters.currentRP - 1) )
	}
}

const mutations = {

}

export default {
	namespaced: true,
	getters,
	actions,
	mutations,
	modules,
}